import React from "react";
import {useCollapse} from "react-collapsed";
import translate from "components/translations/translations.wrapper";

export const Preferences = ({...props}: any): React.ReactElement => {

    const {getCollapseProps, getToggleProps} = useCollapse();

    return <div>
        <div {...getToggleProps()} className={"bg-grey p-16"}>
            <h3>{props.translate("settings.otherSettings")}</h3>
            <div>{props.translate("settings.preferencesMoreInfo")}</div>
        </div>
        <section {...getCollapseProps()} className={"mt-4 py-16"}>Content here...</section>
    </div>
}

const withTranslations = translate(Preferences);
export default withTranslations;